module.exports = function() {
  return new Worker(__webpack_public_path__ + "89b04dc81e7b926c9119.worker.js");
};